import { fireAnalyticEvent } from '@ergeon/erg-utils-js';

export const track = (eventName: string, data?: object) => {
  // @ts-ignore
  const dataLayer = window.dataLayer;

  if (!dataLayer) {
    console.warn('GTM dataLayer not available');
    return;
  }

  const userId = window.sessionStorage.getItem('user_id');

  try {
    fireAnalyticEvent({
      event: eventName,
      ...data,
      ...(userId && { user_id: userId }),
    });
  } catch (error) {
    console.warn('Analytics track failed:', error);
  }

  if (process.env.NODE_ENV !== 'production') {
    console.info(
      `%cEvent %c ${eventName}`,
      'color: #FF8118; font-size:16px;',
      'color: #00B9F3; font-size:16px;',
      data,
    );
  }
};
